import Crud from './crud'
var crud = new Crud('tranferstores', 'kho trung chuyển');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Name: ''
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
